export const html = "<p>Ride the Wings of Tatev, the world&#39;s longest reversible ropeway.</p>\n";
export const leadHtml = "<p>Ride the Wings of Tatev, the world&#39;s longest reversible ropeway.</p>\n";
export const bodyHtml = "";
export const metaText = "Ride the Wings of Tatev, the world's longest reversible ropeway.";